import { render } from "./NotFoundPageCms.vue?vue&type=template&id=bdb119b6&scoped=true"
import script from "./NotFoundPageCms.vue?vue&type=script&lang=js"
export * from "./NotFoundPageCms.vue?vue&type=script&lang=js"

import "./NotFoundPageCms.vue?vue&type=style&index=0&id=bdb119b6&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdb119b6"]])

export default __exports__